export default [
  {
    path: "databasefinance",
    name: "Cơ sở dữ liệu tài chính",
    redirect: "/databasefinance/settlement",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "settlement",
        name: "Báo cáo quyết toán",
        component: () => import("@/views/screens/databasefinances/settlement"),
        meta: {
          requiresAuth: true,
          title: "Báo cáo quyết toán",
        },
      },
      {
        path: "asset",
        name: "Báo cáo tài sản",
        component: () => import("@/views/screens/databasefinances/asset"),
        meta: {
          requiresAuth: true,
          title: "Báo cáo tài sản",
        },
      },
    ],
  },
];
